import React, { useContext } from 'react';
import { Stack } from '@fluentui/react';
import {
  SaveAndExitButton,
  CancelButton,
} from '@bingads-webui-react/wizard-ui-library';
import { I18nContext } from '@bingads-webui-react/i18n-context';

export const EditFooter = () => {
  const i18n = useContext(I18nContext);

  return (
    <Stack horizontal tokens={{ childrenGap: 16 }}>
      <SaveAndExitButton buttonText={i18n.getString(_TL_('Save'))} />
      <CancelButton buttonText={i18n.getString(_TL_('Cancel'))} />
    </Stack>
  );
};
